import * as React from 'react';

import './input-group.css';
import { InfoIcon } from './info-icon/info-icon';

interface IProps {
    label: string;
    info?: string;
    children: React.ReactNode;
}

export const InputGroup = (props: IProps) => {
    return (
        <div className='input-group'>
            <div className='label-wrapper'>
                <label>{props.label}</label>
                {props.info ? <InfoIcon text={props.info} /> : null}
            </div>
            <div>
                {props.children}
            </div>
        </div>
    );
};